import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import { fetchTimesheet, minutosParaTexto } from '../../api/worklog';
import { fetchAnalistas } from '../../api/usuarios';
import './Worklog.css';

function iso(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; }
function inicioSemana(base) { const d = new Date(base); const dia = (d.getDay() + 6) % 7; d.setDate(d.getDate() - dia); return d; }
function formatarData(s) { const [y, m, dd] = String(s).slice(0, 10).split('-'); return dd ? `${dd}/${m}/${y}` : s; }
function diaSemana(s) { const [y, m, dd] = String(s).slice(0, 10).split('-').map(Number); return new Date(y, m - 1, dd).toLocaleDateString('pt-BR', { weekday: 'short' }); }

function Timesheet() {
    const history = useHistory();
    const seg = inicioSemana(new Date());
    const dom = new Date(seg); dom.setDate(seg.getDate() + 6);

    const [usuarioId, setUsuarioId] = useState(localStorage.getItem('codUsu') || '');
    const [de, setDe] = useState(iso(seg));
    const [ate, setAte] = useState(iso(dom));
    const [analistas, setAnalistas] = useState([]);
    const [dados, setDados] = useState({ entradas: [], total_minutos: 0 });
    const [loading, setLoading] = useState(false);

    const verificar = useCallback(async () => {
        const ok = await verificandoApp('ATENDENTE');
        if (!ok) history.push('/');
    }, [history]);

    const carregar = useCallback(async () => {
        verificandoToken();
        if (!usuarioId) return;
        setLoading(true);
        try {
            const d = await fetchTimesheet({ usuario_id: usuarioId, de, ate });
            setDados(d || { entradas: [], total_minutos: 0 });
        } finally { setLoading(false); }
    }, [usuarioId, de, ate]);

    useEffect(() => { verificar(); fetchAnalistas().then((l) => setAnalistas(Array.isArray(l) ? l : [])); }, [verificar]);
    useEffect(() => { carregar(); }, [carregar]);

    const semana = (delta) => {
        const novaSeg = new Date(de); novaSeg.setDate(novaSeg.getDate() + delta * 7);
        const i = inicioSemana(novaSeg); const f = new Date(i); f.setDate(i.getDate() + 6);
        setDe(iso(i)); setAte(iso(f));
    };

    const porDia = {};
    (dados.entradas || []).forEach((e) => {
        const k = String(e.data).slice(0, 10);
        (porDia[k] = porDia[k] || []).push(e);
    });
    const dias = Object.keys(porDia).sort();

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado wl-page">
                    <div className="page-header">
                        <h1 className="mb-0"><i className="fas fa-calendar-week me-2" />Timesheet</h1>
                        <p className="text-muted small mb-0">Horas lançadas por colaborador na semana.</p>
                    </div>

                    <div className="wl-filtros d-flex flex-wrap align-items-end gap-2 my-3">
                        <div>
                            <label className="small d-block">Colaborador</label>
                            <select className="form-control form-control-sm" value={usuarioId} onChange={(e) => setUsuarioId(e.target.value)} style={{ minWidth: 220 }}>
                                <option value="">Selecione...</option>
                                {analistas.map((a) => <option key={a.USUSEQ ?? a.ususeq} value={a.USUSEQ ?? a.ususeq}>{a.USRNOMCPL ?? a.usrnomcpl ?? ('Usuário ' + (a.USUSEQ ?? a.ususeq))}</option>)}
                            </select>
                        </div>
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => semana(-1)} title="Semana anterior"><i className="fas fa-chevron-left" /></button>
                        <div>
                            <label className="small d-block">De</label>
                            <input type="date" className="form-control form-control-sm" value={de} onChange={(e) => setDe(e.target.value)} />
                        </div>
                        <div>
                            <label className="small d-block">Até</label>
                            <input type="date" className="form-control form-control-sm" value={ate} onChange={(e) => setAte(e.target.value)} />
                        </div>
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => semana(1)} title="Próxima semana"><i className="fas fa-chevron-right" /></button>
                        <div className="ms-auto wl-total-chip">
                            Total: <strong>{minutosParaTexto(dados.total_minutos)}</strong>
                        </div>
                    </div>

                    {loading && <p className="text-muted">Carregando...</p>}
                    {!loading && dias.length === 0 && <div className="alert alert-info py-3">Nenhuma hora lançada neste período.</div>}

                    {!loading && dias.map((dia) => {
                        const itens = porDia[dia];
                        const subtotal = itens.reduce((a, e) => a + (Number(e.minutos) || 0), 0);
                        return (
                            <div key={dia} className="card wl-dia-card mb-2">
                                <div className="card-header d-flex justify-content-between align-items-center py-2">
                                    <span><strong>{formatarData(dia)}</strong> <span className="text-muted small text-capitalize">· {diaSemana(dia)}</span></span>
                                    <span className="badge bg-primary">{minutosParaTexto(subtotal)}</span>
                                </div>
                                <div className="card-body p-0">
                                    <table className="table table-sm mb-0 wl-table">
                                        <tbody>
                                            {itens.map((e) => (
                                                <tr key={e.id}>
                                                    <td className="text-nowrap" style={{ width: 90 }}>{minutosParaTexto(e.minutos)}</td>
                                                    <td className="text-nowrap"><button className="btn btn-link btn-sm p-0" onClick={() => history.push(`/historicoSati/${e.sat_num}`)}>#{e.sat_num}</button></td>
                                                    <td>{e.descricao || <span className="text-muted">{e.chamado_descricao ? String(e.chamado_descricao).slice(0, 80) : '—'}</span>}</td>
                                                    <td className="text-center" style={{ width: 50 }}>{e.faturavel !== 0 ? <i className="fas fa-dollar-sign text-success" title="Faturável" /> : <i className="fas fa-minus text-muted" />}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </main>
        </div>
    );
}

export default Timesheet;
